// GENERATED from npc.store by tools/npc-store.js — do not edit.
// Edit the store (or the knobs app NPCs tab), then re-run the generator.
// The store is the single source of truth; this module is its projection
// the whole codebase imports (sim enemy stats, arena NPC select, the
// sprite lab's NPC subjects, the renderer's family/tint lookup).
export const NPCS_DATA = [
  {
    "kind": "goblin",
    "name": "[Base Goblin]",
    "family": "goblin",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":10,"atkMin":1,"atkMax":5,"speedTicks":60,"attack":20,"meleeDef":20,"magicDef":20,"range":1,"moveSpeedTicks":20},
  },
  {
    "kind": "goblin-000000",
    "name": "Evil Goblin",
    "family": "goblin",
    "tint": "000000",
    "shade": "#000000",
    "style": "melee",
    "stackable": false,
    "lootTable": 1,
    "stats": {"maxHp":70,"atkMin":1,"atkMax":20,"speedTicks":60,"attack":50,"meleeDef":50,"magicDef":50,"range":1,"moveSpeedTicks":20},
  },
  {
    "kind": "goblin-613583",
    "name": "Freak Goblin",
    "family": "goblin",
    "tint": "613583",
    "shade": "#613583",
    "style": "melee",
    "stackable": false,
    "lootTable": 1,
    "stats": {"maxHp":15,"atkMin":1,"atkMax":5,"speedTicks":10,"attack":50,"meleeDef":0,"magicDef":0,"range":1,"moveSpeedTicks":20},
  },
  {
    "kind": "goblin-62a0ea",
    "name": "Icy Goblin",
    "family": "goblin",
    "tint": "62a0ea",
    "shade": "#62a0ea",
    "style": "melee",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":35,"atkMin":1,"atkMax":7,"speedTicks":60,"attack":30,"meleeDef":30,"magicDef":20,"range":1,"moveSpeedTicks":20},
  },
  {
    "kind": "goblin-ff2600",
    "name": "Fire Goblin",
    "family": "goblin",
    "tint": "ff2600",
    "shade": "#ff2600",
    "style": "melee",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":50,"atkMin":1,"atkMax":12,"speedTicks":60,"attack":40,"meleeDef":40,"magicDef":40,"range":1,"moveSpeedTicks":20},
  },
  {
    "kind": "goblin-ffffff",
    "name": "Holy Goblin",
    "family": "goblin",
    "tint": "ffffff",
    "shade": "#ffffff",
    "style": "melee",
    "stackable": false,
    "lootTable": 1,
    "stats": {"maxHp":100,"atkMin":1,"atkMax":50,"speedTicks":120,"attack":70,"meleeDef":100,"magicDef":100,"range":1,"moveSpeedTicks":50},
  },
  {
    "kind": "npc-1",
    "name": "Goblin",
    "family": "goblin",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":20,"atkMin":1,"atkMax":5,"speedTicks":60,"attack":20,"meleeDef":20,"magicDef":20,"range":1,"moveSpeedTicks":20},
  },
  {
    "kind": "npc-10",
    "name": "Fiery Shade",
    "family": "shade",
    "tint": "ff2600",
    "shade": "#ff2600",
    "style": "magic",
    "stackable": false,
    "lootTable": 1,
    "stats": {"maxHp":50,"atkMin":1,"atkMax":9,"speedTicks":30,"attack":30,"meleeDef":20,"magicDef":50,"range":7,"moveSpeedTicks":7},
  },
  {
    "kind": "npc-11",
    "name": "Unholy Shade",
    "family": "shade",
    "tint": "000000",
    "shade": "#000000",
    "style": "magic",
    "stackable": false,
    "lootTable": 1,
    "stats": {"maxHp":80,"atkMin":1,"atkMax":15,"speedTicks":30,"attack":50,"meleeDef":50,"magicDef":50,"range":7,"moveSpeedTicks":7},
  },
  {
    "kind": "npc-12",
    "name": "[Base Skeleton]",
    "family": "skeleton",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "lootTable": null,
    "stats": {"maxHp":10,"atkMin":1,"atkMax":5,"speedTicks":50,"attack":20,"meleeDef":20,"magicDef":20,"range":1,"moveSpeedTicks":10},
  },
  {
    "kind": "npc-13",
    "name": "Icy Skeleton",
    "family": "skeleton",
    "tint": "62a0ea",
    "shade": "#62a0ea",
    "style": "melee",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":20,"atkMin":1,"atkMax":7,"speedTicks":50,"attack":20,"meleeDef":20,"magicDef":20,"range":1,"moveSpeedTicks":10},
  },
  {
    "kind": "npc-14",
    "name": "Fire Skeleton",
    "family": "skeleton",
    "tint": "ff2600",
    "shade": "#ff2600",
    "style": "melee",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":30,"atkMin":1,"atkMax":9,"speedTicks":50,"attack":20,"meleeDef":20,"magicDef":20,"range":1,"moveSpeedTicks":10},
  },
  {
    "kind": "npc-15",
    "name": "Spooky Skeleton",
    "family": "skeleton",
    "tint": "000000",
    "shade": "#000000",
    "style": "melee",
    "stackable": false,
    "lootTable": 1,
    "stats": {"maxHp":30,"atkMin":1,"atkMax":30,"speedTicks":50,"attack":20,"meleeDef":20,"magicDef":20,"range":1,"moveSpeedTicks":10},
  },
  {
    "kind": "npc-16",
    "name": "Holy Skeleton",
    "family": "skeleton",
    "tint": "000000",
    "shade": "#000000",
    "style": "melee",
    "stackable": false,
    "lootTable": 1,
    "stats": {"maxHp":75,"atkMin":1,"atkMax":20,"speedTicks":50,"attack":50,"meleeDef":50,"magicDef":20,"range":1,"moveSpeedTicks":10},
  },
  {
    "kind": "npc-17",
    "name": "[Base Zombie]",
    "family": "zombie",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "lootTable": null,
    "stats": {"atkMin":1,"atkMax":3,"speedTicks":100,"attack":0,"magicDef":0,"range":1,"moveSpeedTicks":50,"maxHp":30,"meleeDef":100},
  },
  {
    "kind": "npc-18",
    "name": "Zombie",
    "family": "zombie",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "lootTable": 0,
    "stats": {"atkMin":1,"atkMax":3,"speedTicks":100,"attack":0,"magicDef":0,"range":1,"moveSpeedTicks":50,"maxHp":30,"meleeDef":100},
  },
  {
    "kind": "npc-19",
    "name": "Tank Zombie",
    "family": "zombie",
    "tint": "77767b",
    "shade": "#77767b",
    "style": "melee",
    "stackable": false,
    "lootTable": 1,
    "stats": {"atkMin":1,"atkMax":5,"speedTicks":100,"attack":0,"magicDef":100,"range":1,"moveSpeedTicks":50,"maxHp":250,"meleeDef":100},
  },
  {
    "kind": "npc-2",
    "name": "[Base Ghost]",
    "family": "ghost",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "lootTable": null,
    "stats": {"maxHp":5,"atkMin":1,"atkMax":3,"speedTicks":60,"meleeDef":0,"magicDef":0,"range":1,"moveSpeedTicks":30,"attack":30},
  },
  {
    "kind": "npc-20",
    "name": "This Zombie Won't Die Easily",
    "family": "zombie",
    "tint": "000000",
    "shade": "#000000",
    "style": "melee",
    "stackable": false,
    "lootTable": 1,
    "stats": {"atkMin":1,"atkMax":10,"speedTicks":100,"attack":0,"magicDef":100,"range":1,"moveSpeedTicks":50,"maxHp":500,"meleeDef":100},
  },
  {
    "kind": "npc-22",
    "name": "[Base Wizard]",
    "family": "wizard",
    "tint": "canon",
    "shade": null,
    "style": "magic",
    "stackable": false,
    "lootTable": 0,
    "spellColor": "#ff2f92",
    "spellRadius": 30,
    "stats": {"maxHp":30,"atkMin":1,"atkMax":10,"speedTicks":50,"attack":0,"meleeDef":0,"magicDef":0,"range":5,"moveSpeedTicks":7},
  },
  {
    "kind": "npc-23",
    "name": "Wizard",
    "family": "wizard",
    "tint": "canon",
    "shade": null,
    "style": "magic",
    "stackable": false,
    "lootTable": 0,
    "spellColor": "#ff2f92",
    "spellRadius": 30,
    "stats": {"maxHp":30,"atkMin":1,"atkMax":10,"speedTicks":50,"attack":0,"meleeDef":0,"range":5,"moveSpeedTicks":7,"magicDef":0},
  },
  {
    "kind": "npc-24",
    "name": "Fire Wizard",
    "family": "wizard",
    "tint": "ff2600",
    "shade": "#ff2600",
    "style": "magic",
    "stackable": false,
    "lootTable": 0,
    "spellColor": "#ff2600",
    "spellRadius": 30,
    "stats": {"maxHp":50,"atkMin":1,"atkMax":20,"speedTicks":50,"attack":0,"magicDef":0,"range":5,"moveSpeedTicks":7,"meleeDef":0},
  },
  {
    "kind": "npc-25",
    "name": "Wizard of Death",
    "family": "wizard",
    "tint": "000000",
    "shade": "#000000",
    "style": "magic",
    "stackable": false,
    "lootTable": 1,
    "spellColor": "#000000",
    "spellRadius": 30,
    "stats": {"maxHp":100,"atkMin":1,"atkMax":30,"speedTicks":50,"attack":0,"magicDef":50,"range":5,"moveSpeedTicks":7,"meleeDef":20},
  },
  {
    "kind": "npc-26",
    "name": "[Base Mephit]",
    "family": "mephit",
    "tint": "canon",
    "shade": null,
    "style": "magic",
    "stackable": false,
    "lootTable": 0,
    "spellColor": "#932092",
    "stats": {"maxHp":10,"atkMin":1,"speedTicks":30,"attack":50,"magicDef":20,"range":5,"moveSpeedTicks":7,"atkMax":3,"meleeDef":0},
  },
  {
    "kind": "npc-27",
    "name": "Ice Mephit",
    "family": "mephit",
    "tint": "619fe9",
    "shade": "#619fe9",
    "style": "magic",
    "stackable": false,
    "lootTable": 0,
    "spellColor": "#932092",
    "stats": {"maxHp":10,"atkMin":1,"speedTicks":30,"attack":20,"magicDef":20,"range":5,"moveSpeedTicks":7,"atkMax":3,"meleeDef":0},
  },
  {
    "kind": "npc-28",
    "name": "Fire Mephit",
    "family": "mephit",
    "tint": "ff2600",
    "shade": "#ff2600",
    "style": "magic",
    "stackable": false,
    "lootTable": 0,
    "spellColor": "#932092",
    "stats": {"maxHp":15,"atkMin":1,"speedTicks":30,"attack":20,"magicDef":20,"range":5,"moveSpeedTicks":7,"atkMax":5,"meleeDef":0},
  },
  {
    "kind": "npc-29",
    "name": "Mephit of Darkness",
    "family": "mephit",
    "tint": "000000",
    "shade": "#000000",
    "style": "magic",
    "stackable": false,
    "lootTable": 0,
    "spellColor": "#932092",
    "stats": {"maxHp":20,"atkMin":1,"speedTicks":30,"attack":30,"magicDef":20,"range":5,"moveSpeedTicks":7,"atkMax":7,"meleeDef":0},
  },
  {
    "kind": "npc-3",
    "name": "Icy Ghost",
    "family": "ghost",
    "tint": "619fe9",
    "shade": "#619fe9",
    "style": "melee",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":25,"atkMin":1,"atkMax":5,"speedTicks":60,"meleeDef":10,"magicDef":10,"range":1,"moveSpeedTicks":30,"attack":40},
  },
  {
    "kind": "npc-30",
    "name": "Illuminated Mephit",
    "family": "mephit",
    "tint": "feffff",
    "shade": "#feffff",
    "style": "magic",
    "stackable": false,
    "lootTable": 1,
    "spellColor": "#932092",
    "stats": {"maxHp":30,"atkMin":1,"speedTicks":30,"attack":40,"magicDef":20,"range":5,"moveSpeedTicks":7,"atkMax":12,"meleeDef":0},
  },
  {
    "kind": "npc-4",
    "name": "Ghost",
    "family": "ghost",
    "tint": "canon",
    "shade": null,
    "style": "melee",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":20,"atkMin":1,"atkMax":3,"speedTicks":60,"meleeDef":0,"magicDef":0,"range":1,"moveSpeedTicks":30,"attack":30},
  },
  {
    "kind": "npc-5",
    "name": "Spooky Ghost",
    "family": "ghost",
    "tint": "000000",
    "shade": "#000000",
    "style": "melee",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":30,"atkMin":1,"atkMax":20,"speedTicks":60,"meleeDef":0,"magicDef":0,"range":1,"moveSpeedTicks":30,"attack":60},
  },
  {
    "kind": "npc-6",
    "name": "Cursed Ghost",
    "family": "ghost",
    "tint": "220000",
    "shade": "#220000",
    "style": "melee",
    "stackable": false,
    "lootTable": 1,
    "stats": {"maxHp":35,"atkMin":1,"atkMax":90,"speedTicks":200,"magicDef":0,"range":1,"moveSpeedTicks":100,"attack":50,"meleeDef":0},
  },
  {
    "kind": "npc-7",
    "name": "[Base Shade]",
    "family": "shade",
    "tint": "canon",
    "shade": null,
    "style": "magic",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":20,"atkMin":1,"atkMax":5,"speedTicks":30,"attack":20,"meleeDef":10,"magicDef":50,"range":7,"moveSpeedTicks":7},
  },
  {
    "kind": "npc-8",
    "name": "Icy Shade",
    "family": "shade",
    "tint": "62a0ea",
    "shade": "#62a0ea",
    "style": "magic",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":30,"atkMin":1,"atkMax":7,"speedTicks":30,"attack":40,"meleeDef":20,"magicDef":50,"range":7,"moveSpeedTicks":7},
  },
  {
    "kind": "npc-9",
    "name": "Shade",
    "family": "shade",
    "tint": "canon",
    "shade": null,
    "style": "magic",
    "stackable": false,
    "lootTable": 0,
    "stats": {"maxHp":20,"atkMin":1,"atkMax":5,"speedTicks":30,"attack":20,"meleeDef":10,"magicDef":50,"range":7,"moveSpeedTicks":7},
  },
] as const;
